module.exports = __webpack_public_path__ + "img/ep_promotion.fc29fd4c.png";